import { render, staticRenderFns } from "./ConfirmedFaces.vue?vue&type=template&id=41ce6f5c&"
import script from "./ConfirmedFaces.vue?vue&type=script&lang=js&"
export * from "./ConfirmedFaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports